export const COLUMNS = [
  {
    Header: 'Brand',
    accessor: 'name',
  },
  {
    Header: 'Website',
    accessor: 'website',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Logo',
    accessor: 'logo',
  },
  {
    Header: 'Edit/Delete',
    accessor: '',
  },
];
